// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingActionHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Alert from 'share/components/controls/Izenda.Alert';
import Button from 'share/components/controls/Izenda.Button';
import connect from 'share/enhancers/Izenda.Connect';

const RenderActionHeader = (props: any) => {
  const {
    localization,
    cancelChangeConfig,
    saveConfig,
    store: { alertDetails },
    resetAlert
  } = props;
  return (
    <GridLayout>
      <GridLayout.Row>
        <GridLayout.Col cols={9}>
          <Alert type={alertDetails.alertType} onAutoHide={resetAlert}>
            {alertDetails.message}
          </Alert>
        </GridLayout.Col>
        <GridLayout.Col cols={3}>
          <Button
            label={localization.getText('COMMON_LABEL_CANCEL')}
            className='u_floatRight btn-report-default'
            onClick={cancelChangeConfig}
          />
          <Button
            label={localization.getText('COMMON_LABEL_SAVE')}
            className='u_marginLeftRight u_floatRight btn-primary'
            onClick={saveConfig}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>
  );
};

RenderActionHeader.propsType = {
  store: PropTypes.object,
  localization: PropTypes.object,
  saveConfig: PropTypes.func,
  cancelChangeConfig: PropTypes.func,
  resetAlert: PropTypes.func
};

export default connect()(RenderActionHeader);



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Izenda.SettingActionHeader.js